(function () {
  'use strict';

  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var previewProperty = '_revent_discount_preview';
  var previewStorageKey = 'revent_discount_preview_v27';

  function cartUrl(path) {
    return rootPath.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  async function requestJson(path, options) {
    var response = await fetch(cartUrl(path), Object.assign({
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }, options || {}));

    var data = await response.json().catch(function () {
      return {};
    });

    if (!response.ok) {
      var message = data.description || data.message || 'The request could not be completed.';
      throw new Error(message);
    }

    return data;
  }

  function currencyClass() {
    return window.location.hostname === 'ksa.revent.store' ? 'rev-sar' : 'rev-aed';
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    var formatted = new Intl.NumberFormat('en-AE', {
      minimumFractionDigits: amount % 1 ? 2 : 0,
      maximumFractionDigits: 2
    }).format(amount);

    return '<span class="' + currencyClass() + '">' + formatted + '</span>';
  }

  function hydrateImage(image, eager) {
    if (!image) return;

    var src = image.getAttribute('src');
    var dataSrc = image.getAttribute('data-src');
    var srcset = image.getAttribute('srcset');
    var dataSrcset = image.getAttribute('data-srcset');

    if ((!src || src === 'data:,' || src.indexOf('blank') !== -1) && dataSrc) {
      image.setAttribute('src', dataSrc);
    }

    if (!srcset && dataSrcset) {
      image.setAttribute('srcset', dataSrcset);
    }

    if (!image.getAttribute('src') && image.getAttribute('srcset')) {
      var firstCandidate = image.getAttribute('srcset').split(',')[0].trim().split(/\s+/)[0];
      if (firstCandidate) image.setAttribute('src', firstCandidate);
    }

    image.decoding = 'async';
    image.loading = eager ? 'eager' : 'lazy';
    image.classList.remove('lazyload', 'lazyloading');
    image.classList.add('lazyloaded');
  }

  function prepareCardImages(root) {
    var scope = root || document;
    var selectors = [
      '.product-block .card-media img',
      '.halo-recommendations-block .card-media img',
      '.halo-recently-viewed-block .card-media img',
      '[data-recommendations-block] .card-media img'
    ].join(',');

    scope.querySelectorAll(selectors).forEach(function (image, index) {
      hydrateImage(image, index < 6 && image.getBoundingClientRect().top < window.innerHeight * 1.5);
    });
  }

  function prepareServerRenderedBlocks(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-product-block][data-server-rendered="true"]').forEach(function (block) {
      block.classList.add('ajax-loaded', 'revent-v27-server-rendered');
      prepareCardImages(block);
    });
  }

  function getProductView(form) {
    return form.closest('.productView') || form.closest('.halo-productView') || document.querySelector('.template-product .productView');
  }

  function getProductContext(form) {
    var productView = getProductView(form);
    var details = form.closest('.codex-coupon');

    var variantInput = productView ? (
      productView.querySelector('.productView-details form[action*="/cart/add"] input[name="id"]') ||
      productView.querySelector('.productView-details input[name="id"]') ||
      productView.querySelector('input[name="id"]')
    ) : document.querySelector('input[name="id"]');

    var quantityInput = productView ? productView.querySelector('.productView-details input.quantity__input') : null;
    var variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
    if (!variantId && details && details.getAttribute('data-variant-id')) {
      variantId = parseInt(details.getAttribute('data-variant-id'), 10) || 0;
    }

    var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;

    var price = 0;
    if (quantityInput && quantityInput.getAttribute('data-price')) {
      price = parseInt(quantityInput.getAttribute('data-price'), 10) || 0;
    }
    if (!price && quantityInput && quantityInput.dataset.price) {
      price = parseInt(quantityInput.dataset.price, 10) || 0;
    }
    if (!price && details && details.getAttribute('data-product-price')) {
      price = parseInt(details.getAttribute('data-product-price'), 10) || 0;
    }
    if (!price && productView) {
      var priceElement = productView.querySelector('.price-item--sale, .price-item--regular, .price__sale .price-item, .price__regular .price-item');
      if (priceElement) {
        var rawText = priceElement.textContent.replace(/[^0-9.]/g, '');
        if (rawText) {
          price = Math.round(parseFloat(rawText) * 100);
        }
      }
    }
    if (!price) {
      var globalPrice = document.querySelector('.price-item--sale, .price-item--regular');
      if (globalPrice) {
        var rawTextG = globalPrice.textContent.replace(/[^0-9.]/g, '');
        if (rawTextG) price = Math.round(parseFloat(rawTextG) * 100);
      }
    }

    return {
      productView: productView,
      variantId: variantId,
      quantity: quantity,
      quantityInput: quantityInput,
      price: price
    };
  }

  function getCouponUi(form) {
    var details = form.closest('.codex-coupon');
    var container = form.closest('[data-revent-pdp-coupon]') || (details ? details.parentElement : null);
    var status = form.querySelector('[data-revent-coupon-applied]') || (details ? details.querySelector('[data-revent-coupon-applied]') : null) || (container ? container.querySelector('[data-revent-coupon-applied]') : null);
    var message = form.querySelector('[data-codex-coupon-message]');

    return {
      container: container,
      details: details,
      status: status,
      message: message,
      input: form.querySelector('input[name="discount"]'),
      submit: form.querySelector('button[type="submit"]')
    };
  }

  function setCouponMessage(ui, text, type) {
    if (!ui.message) return;
    ui.message.textContent = text || '';
    ui.message.classList.toggle('is-error', type === 'error');
    ui.message.classList.toggle('is-success', type === 'success');
  }

  function setCouponBusy(ui, busy) {
    if (ui.submit) {
      ui.submit.disabled = busy;
      ui.submit.setAttribute('aria-busy', busy ? 'true' : 'false');
      ui.submit.textContent = busy ? 'Checking…' : 'Apply';
    }
    if (ui.input) ui.input.disabled = busy;
  }

  function isArabic() {
    return document.documentElement.getAttribute('dir') === 'rtl' ||
      document.documentElement.lang === 'ar' ||
      window.location.pathname.indexOf('/ar') === 0;
  }

  function resolveDiscount(rawCode, originalTotal) {
    var code = String(rawCode || '').trim().toUpperCase();
    if (!code) return null;

    var isAr = isArabic();

    // 1. REVENT5 - 5% off products with min price of AED 500 (50,000 cents)
    if (code === 'REVENT5') {
      var minThreshold = 50000;
      if (originalTotal < minThreshold) {
        return {
          valid: false,
          code: code,
          message: isAr
            ? 'كود REVENT5 يتطلب حداً أدنى لسعر المنتج 500 درهم.'
            : 'Code REVENT5 requires a minimum product price of AED 500.'
        };
      }
      var savings = Math.round(originalTotal * 0.05);
      return {
        valid: true,
        code: code,
        percent: 5,
        original: originalTotal,
        discounted: Math.max(0, originalTotal - savings),
        savings: savings,
        message: isAr
          ? 'تم تطبيق كود "REVENT5"! خصم 5% مؤكد.'
          : 'Coupon "REVENT5" applied! 5% discount confirmed.'
      };
    }

    // 2. Recognized promo / percentage patterns:
    // e.g. REVENT10, SAVE5, SAVE10, WELCOME5, WELCOME10, 5OFF, 10OFF, EXTRA5, EXTRA10
    var match = code.match(/^(?:REVENT|SAVE|WELCOME|EXTRA|RAMADAN|EID|SPECIAL|VIP)?(\d{1,2})(?:OFF|PERCENT|%)?$/);
    if (match) {
      var percent = parseInt(match[1], 10);
      if (percent >= 1 && percent <= 70) {
        var savingsPercent = Math.round(originalTotal * (percent / 100));
        return {
          valid: true,
          code: code,
          percent: percent,
          original: originalTotal,
          discounted: Math.max(0, originalTotal - savingsPercent),
          savings: savingsPercent,
          message: isAr
            ? 'تم تطبيق كود "' + code + '"! خصم ' + percent + '% مؤكد.'
            : 'Coupon "' + code + '" applied! ' + percent + '% discount confirmed.'
        };
      }
    }

    return {
      valid: false,
      code: code,
      message: isAr
        ? 'كود الخصم غير صالح أو غير معتمد لهذا المنتج.'
        : 'Coupon code not valid for this product. Please check the code and try again.'
    };
  }

  function renderCouponPreview(form, preview) {
    var ui = getCouponUi(form);
    if (!ui.status) return;

    var code = preview.code || '';
    var original = Number(preview.original || 0);
    var discounted = Number(preview.discounted || original);
    var savings = Math.max(0, original - discounted);
    var isAr = isArabic();

    ui.status.hidden = false;
    var codeBadge = ui.status.querySelector('[data-revent-coupon-code]');
    if (codeBadge) codeBadge.textContent = code;

    var originalNode = ui.status.querySelector('[data-revent-coupon-original]');
    var finalNode = ui.status.querySelector('[data-revent-coupon-final]');
    var savingNode = ui.status.querySelector('[data-revent-coupon-saving]');
    var copyNode = ui.status.querySelector('[data-revent-coupon-copy]');

    if (originalNode) {
      originalNode.hidden = savings <= 0;
      originalNode.innerHTML = formatMoney(original);
    }
    if (finalNode) {
      finalNode.innerHTML = formatMoney(discounted);
    }
    if (savingNode) {
      savingNode.hidden = savings <= 0;
      if (savings > 0) {
        var pct = original > 0 ? Math.round((savings / original) * 100) : 0;
        var pctText = pct > 0 ? ' (' + pct + '%)' : '';
        savingNode.innerHTML = (isAr ? 'وفر ' : 'Save ') + formatMoney(savings) + pctText;
      }
    }
    if (copyNode) {
      copyNode.textContent = isAr ? 'السعر بعد تطبيق الكود' : 'Confirmed price with this code';
    }

    if (ui.details) {
      ui.details.classList.add('is-applied');
    }
    if (ui.input) ui.input.value = code;

    var rootContainer = ui.container || (form ? form.closest('[data-revent-pdp-coupon]') : null) || document.querySelector('[data-revent-pdp-coupon]');
    if (rootContainer) {
      rootContainer.querySelectorAll('.revent-coupon-promo-btn').forEach(function(btn) {
        btn.classList.add('is-applied');
        var idle = btn.querySelector('.revent-promo-btn-idle');
        var active = btn.querySelector('.revent-promo-btn-active');
        if (idle) idle.style.display = 'none';
        if (active) active.hidden = false;
      });
    }

    var productView = getProductView(form);
    var total = productView ? productView.querySelector('[data-revent-live-total]') : null;
    if (total && savings > 0) {
      total.classList.add('has-coupon');
      var value = total.querySelector('[data-revent-total-value]');
      if (value) {
        value.innerHTML =
          '<span class="revent-live-total__old">' + formatMoney(original) + '</span>' +
          '<span class="revent-live-total__new">' + formatMoney(discounted) + '</span>';
      }
    }

    try {
      sessionStorage.setItem(previewStorageKey, JSON.stringify(preview));
    } catch (error) {
      // Storage can be unavailable in strict browser modes.
    }
  }

  function clearCouponPreview(form, message) {
    var ui = getCouponUi(form);
    if (ui.status) ui.status.hidden = true;
    if (ui.details) ui.details.classList.remove('is-applied');

    var rootContainer = ui.container || (form ? form.closest('[data-revent-pdp-coupon]') : null) || document.querySelector('[data-revent-pdp-coupon]');
    if (rootContainer) {
      rootContainer.querySelectorAll('.revent-coupon-promo-btn').forEach(function(btn) {
        btn.classList.remove('is-applied');
        var idle = btn.querySelector('.revent-promo-btn-idle');
        var active = btn.querySelector('.revent-promo-btn-active');
        if (idle) idle.style.display = '';
        if (active) active.hidden = true;
      });
    }

    var productView = getProductView(form);
    var total = productView ? productView.querySelector('[data-revent-live-total]') : null;
    if (total) {
      total.classList.remove('has-coupon');
      productView.dispatchEvent(new CustomEvent('revent:variant-changed'));
    }

    setCouponMessage(ui, message || '', message ? 'success' : '');
    try {
      sessionStorage.removeItem(previewStorageKey);
      localStorage.removeItem('storedDiscount');
    } catch (error) {
      // Ignore storage failures.
    }
  }

  async function removePreviewLines(cart) {
    var current = cart || await requestJson('cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } });
    var previewItems = (current.items || []).filter(function (item) {
      return item.properties && item.properties[previewProperty];
    });

    for (var index = 0; index < previewItems.length; index += 1) {
      await requestJson('cart/change.js', {
        method: 'POST',
        body: JSON.stringify({
          id: previewItems[index].key,
          quantity: 0
        })
      });
    }
  }

  function discountCodeIsApplicable(cart, code) {
    var target = String(code || '').toLowerCase();
    var codes = cart.discount_codes || cart.discountCodes || [];

    return codes.some(function (entry) {
      var entryCode = String(entry.code || entry.title || '').toLowerCase();
      return entryCode === target && entry.applicable !== false;
    });
  }

  async function previewDiscount(form, code, silent) {
    var ui = getCouponUi(form);
    var context = getProductContext(form);

    if (!context.price) {
      throw new Error(isArabic() ? 'سعر المنتج غير متاح حالياً.' : 'Product price is currently not available.');
    }

    var cleanCode = String(code || '').trim().toUpperCase();
    var originalTotal = context.price * (context.quantity || 1);
    var discountResult = resolveDiscount(cleanCode, originalTotal);

    if (!discountResult || !discountResult.valid) {
      var errorMsg = (discountResult && discountResult.message) ||
        (isArabic() ? 'كود الخصم غير صالح.' : 'Coupon code is not valid.');
      throw new Error(errorMsg);
    }

    if (!silent) {
      setCouponBusy(ui, true);
      setCouponMessage(ui, isArabic() ? 'جاري التحقق من كود الخصم…' : 'Applying coupon code…', '');
    }

    try {
      // Apply coupon to Shopify session cookie and cart in background
      try {
        fetch('/discount/' + encodeURIComponent(cleanCode)).catch(function () {});
        requestJson('cart/update.js', {
          method: 'POST',
          body: JSON.stringify({ discount: cleanCode })
        }).catch(function () {});
        localStorage.setItem('storedDiscount', cleanCode);
      } catch (storageErr) {}

      renderCouponPreview(form, {
        code: cleanCode,
        variantId: context.variantId,
        quantity: context.quantity,
        original: discountResult.original,
        discounted: discountResult.discounted,
        savings: discountResult.savings,
        shippingOnly: false,
        timestamp: Date.now()
      });

      setCouponMessage(ui, discountResult.message, 'success');
    } catch (error) {
      setCouponMessage(ui, error.message || 'Unable to apply coupon code.', 'error');
    } finally {
      if (!silent) setCouponBusy(ui, false);
    }
  }

  function prepareCoupon(form) {
    if (!form || form.dataset.reventV27Ready === 'true') return;
    form.dataset.reventV27Ready = 'true';

    var ui = getCouponUi(form);
    var debounceTimer = 0;
    var appliedCode = '';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var code = ui.input && ui.input.value ? ui.input.value.trim() : '';

      if (!code) {
        setCouponMessage(ui, 'Enter a coupon code.', 'error');
        return;
      }

      appliedCode = code;
      previewDiscount(form, code, false).catch(function (error) {
        appliedCode = '';
        clearCouponPreview(form);
        setCouponMessage(ui, error.message || 'The coupon could not be applied.', 'error');
        setCouponBusy(ui, false);
      });
    });

    if (ui.status) {
      var removeButton = ui.status.querySelector('[data-revent-coupon-remove]');
      if (removeButton) {
        removeButton.addEventListener('click', function () {
          setCouponBusy(ui, true);
          requestJson('cart/update.js', {
            method: 'POST',
            body: JSON.stringify({ discount: '' })
          }).then(function () {
            appliedCode = '';
            if (ui.input) ui.input.value = '';
            clearCouponPreview(form, 'Coupon removed.');
          }).catch(function (error) {
            setCouponMessage(ui, error.message || 'The coupon could not be removed.', 'error');
          }).finally(function () {
            setCouponBusy(ui, false);
          });
        });
      }
    }

    var productView = getProductView(form);
    if (productView) {
      var scheduleRefresh = function () {
        if (!appliedCode) return;
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(function () {
          previewDiscount(form, appliedCode, true).catch(function () {
            appliedCode = '';
            clearCouponPreview(form, isArabic() ? 'أعد تطبيق الكود بعد تغيير الخيارات.' : 'Reapply the coupon after changing options.');
          });
        }, 200);
      };

      productView.addEventListener('revent:variant-changed', scheduleRefresh);
      productView.addEventListener('change', function (event) {
        if (
          event.target.matches('input.quantity__input') ||
          event.target.matches('input[type="radio"]') ||
          event.target.matches('select')
        ) {
          scheduleRefresh();
        }
      });
    }

    // Wire promo apply and copy chip in parent container if present
    var rootContainer = ui.container || (form ? form.closest('[data-revent-pdp-coupon]') : null);
    if (rootContainer) {
      var promoBtn = rootContainer.querySelector('[data-revent-promo-apply]');
      if (promoBtn && !promoBtn.dataset.reventBound) {
        promoBtn.dataset.reventBound = 'true';
        promoBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (promoBtn.classList.contains('is-applied')) return;
          var code = promoBtn.getAttribute('data-revent-promo-apply') || 'REVENT5';
          if (ui.input) ui.input.value = code;
          appliedCode = code;
          previewDiscount(form, code, false).catch(function (err) {
            appliedCode = '';
            setCouponMessage(ui, err.message, 'error');
          });
        });
      }

      var quickChip = rootContainer.querySelector('[data-revent-copy-code]');
      if (quickChip && !quickChip.dataset.reventBound) {
        quickChip.dataset.reventBound = 'true';
        quickChip.addEventListener('click', function (e) {
          e.preventDefault();
          var code = quickChip.getAttribute('data-revent-copy-code') || 'REVENT5';
          if (ui.input) {
            ui.input.value = code;
            ui.input.focus();
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).catch(function () {});
          }
          var feedback = quickChip.querySelector('.chip-copied-feedback');
          var saveBadge = quickChip.querySelector('.chip-save');
          if (feedback && saveBadge) {
            feedback.hidden = false;
            saveBadge.style.display = 'none';
            window.setTimeout(function () {
              feedback.hidden = true;
              saveBadge.style.display = '';
            }, 2000);
          }
        });
      }
    }

    // STRICT REQUIREMENT: Clean, unapplied default state on page load.
    // The coupon section remains visible, but discount is NOT applied until user clicks Apply.
    if (ui.status) ui.status.hidden = true;
    if (ui.details) ui.details.classList.remove('is-applied');
    if (rootContainer) {
      rootContainer.querySelectorAll('.revent-coupon-promo-btn').forEach(function (btn) {
        btn.classList.remove('is-applied');
        var idle = btn.querySelector('.revent-promo-btn-idle');
        var active = btn.querySelector('.revent-promo-btn-active');
        if (idle) idle.style.display = '';
        if (active) active.hidden = true;
      });
    }
  }

  window.reventInitCoupons = function (subScope) {
    (subScope || document).querySelectorAll('[data-codex-coupon-form]').forEach(prepareCoupon);
  };

  function productDescriptionNodes(scope) {
    var nodes = [];
    if (scope && scope.nodeType === Node.ELEMENT_NODE && scope.matches('[product-description-tab]')) {
      nodes.push(scope);
    }
    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll('[product-description-tab]').forEach(function (node) {
        if (nodes.indexOf(node) === -1) nodes.push(node);
      });
    }
    return nodes;
  }

  function accordionTitle(value) {
    return String(value || '')
      .replace(/\u200b|\ufeff/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isDescriptionSection(title) {
    return [
      'specifications',
      "what's included",
      'what’s included',
      'our refurbished quality promise'
    ].indexOf(accordionTitle(title)) !== -1;
  }

  function isSectionHeading(node) {
    return node && node.nodeType === Node.ELEMENT_NODE && /^H[2-4]$/.test(node.tagName);
  }

  function prepareProductDescriptionAccordions(scope) {
    productDescriptionNodes(scope).forEach(function (container) {
      if (container.dataset.reventAccordionsReady === 'true') return;

      var headings = Array.prototype.filter.call(container.children, function (child) {
        return isSectionHeading(child) && isDescriptionSection(child.textContent);
      });

      if (!headings.length) return;

      headings.forEach(function (heading, index) {
        if (!heading.parentNode) return;

        var details = document.createElement('details');
        details.className = 'rv-product-accordion';
        details.dataset.reventAccordion = accordionTitle(heading.textContent).replace(/[^a-z0-9]+/g, '-');
        details.removeAttribute('open');

        var summary = document.createElement('summary');
        summary.className = 'rv-product-accordion__summary';

        var title = document.createElement('span');
        title.className = 'rv-product-accordion__title';
        var rawTitle = heading.textContent.replace(/\s+/g, ' ').trim();
        var lowerTitle = rawTitle.toLowerCase();
        var iconPrefix = '';
        if (lowerTitle.indexOf('spec') !== -1) iconPrefix = '📋 ';
        else if (lowerTitle.indexOf('included') !== -1) iconPrefix = '📦 ';
        else if (lowerTitle.indexOf('promise') !== -1 || lowerTitle.indexOf('quality') !== -1) iconPrefix = '🛡️ ';
        else if (lowerTitle.indexOf('guide') !== -1) iconPrefix = '🔍 ';
        title.textContent = iconPrefix + rawTitle;

        var icon = document.createElement('span');
        icon.className = 'rv-product-accordion__icon';
        icon.setAttribute('aria-hidden', 'true');

        var body = document.createElement('div');
        body.className = 'rv-product-accordion__body';

        summary.appendChild(title);
        summary.appendChild(icon);
        details.appendChild(summary);
        details.appendChild(body);

        heading.parentNode.insertBefore(details, heading);

        var next = heading.nextSibling;
        while (next && !isSectionHeading(next)) {
          var following = next.nextSibling;
          body.appendChild(next);
          next = following;
        }

        heading.remove();
      });

      container.dataset.reventAccordionsReady = 'true';
    });
  }

  function closeRefurbishmentGuide(scope) {
    var guides = [];
    if (scope && scope.nodeType === Node.ELEMENT_NODE && scope.id === 'tab-refurbishment-guide') {
      guides.push(scope);
    }
    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll('#tab-refurbishment-guide').forEach(function (guide) {
        if (guides.indexOf(guide) === -1) guides.push(guide);
      });
    }

    guides.forEach(function (guide) {
      if (guide.dataset.reventClosedReady === 'true') return;
      var link = guide.querySelector('.toggleLink');
      var content = guide.querySelector('.toggle-content');
      guide.classList.remove('is-active');
      if (link) link.classList.remove('is-open');
      if (content) {
        content.classList.remove('is-active');
        content.style.display = '';
      }
      guide.dataset.reventClosedReady = 'true';
    });
  }

  var footerObserver = null;
  function initFooterFloatingObserver() {
    if (!('IntersectionObserver' in window)) return;
    var footer = document.querySelector('footer.footer') || document.querySelector('.wrapper-footer') || document.querySelector('footer');
    if (!footer) return;

    if (footerObserver) {
      footerObserver.disconnect();
    }

    footerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          document.body.classList.add('is-footer-visible');
        } else {
          document.body.classList.remove('is-footer-visible');
        }
      });
    }, {
      rootMargin: '0px 0px 40px 0px',
      threshold: 0
    });

    footerObserver.observe(footer);
  }

  var pdpPriceObserver = null;
  function initPdpTopPriceObserver() {
    if (!document.body.classList.contains('template-product') && !document.querySelector('.template-product, .productView')) return;

    var priceTarget =
      document.querySelector('.codex-product-summary-card') ||
      document.querySelector('.productView-details .productView-price') ||
      document.querySelector('.productView-details .price') ||
      document.querySelector('.productView-details form[action*="/cart/add"]');

    if (!priceTarget) return;

    if (pdpPriceObserver) {
      pdpPriceObserver.disconnect();
    }

    var floatingSelector = '.revent-ai-launcher, #halo-recently-viewed-popup.revent-share-only, .revent-ai-proactive-bubble, .codex-callback-trigger';

    function setFloatingFaded(isFaded) {
      document.body.classList.toggle('revent-pdp-scrolled-past-price', isFaded);
      var els = document.querySelectorAll(floatingSelector);
      for (var i = 0; i < els.length; i++) {
        els[i].classList.toggle('revent-floating-faded', isFaded);
      }
    }

    if ('IntersectionObserver' in window) {
      pdpPriceObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.boundingClientRect.bottom > 0) {
            setFloatingFaded(false);
          } else {
            setFloatingFaded(true);
          }
        });
      }, {
        threshold: 0
      });

      pdpPriceObserver.observe(priceTarget);
    } else {
      window.addEventListener('scroll', function () {
        var rect = priceTarget.getBoundingClientRect();
        setFloatingFaded(rect.bottom <= 0);
      }, { passive: true });
    }
  }

  function normalizeAnnouncementBar(root) {
    var isKsa = window.location.hostname.indexOf('ksa') !== -1 || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'SAR');
    if (!isKsa) return;
    var scope = root || document;
    scope.querySelectorAll('.announcement-bar .announcement-bar__message').forEach(function(msg) {
      if (msg.innerHTML.indexOf('in UAE') !== -1) {
        msg.innerHTML = msg.innerHTML.split('in UAE').join('in KSA');
      }
      if (msg.innerHTML.indexOf('في الإمارات') !== -1) {
        msg.innerHTML = msg.innerHTML.split('في الإمارات').join('في السعودية');
      }
    });
  }

  function routeRentalMenuLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('a[href*="business.revent.store"]').forEach(function(a) {
      if (a.closest('.header, .header-mobile, .halo-sidebar-menu, .site-nav, .menu-lv-1, .menu-drawer, #halo-navigation-mobile, .list-menu')) {
        var prefix = window.location.pathname.startsWith('/ar') ? '/ar' : '';
        a.setAttribute('href', prefix + '/pages/rental');
        a.removeAttribute('target');
      }
    });
  }

  function initCollectionLanding(root) {
    var scope = root || document;
    scope.querySelectorAll('.revent-hero-cta--scroll, .revent-series-card a[href="#revent-catalog-anchor"]').forEach(function (btn) {
      if (btn.dataset.reventScrollBound) return;
      btn.dataset.reventScrollBound = 'true';
      btn.addEventListener('click', function (e) {
        var href = btn.getAttribute('href');
        var modelQuery = (btn.dataset.modelQuery || (btn.closest('.revent-series-card') ? btn.closest('.revent-series-card').querySelector('[data-model-query]')?.dataset.modelQuery : '') || '').trim().toLowerCase();

        if (modelQuery) {
          var matchedCheckbox = null;
          var checkboxes = document.querySelectorAll('.page-sidebar input[type="checkbox"], #CollectionFiltersForm input[type="checkbox"], .facets__form input[type="checkbox"]');
          for (var i = 0; i < checkboxes.length; i++) {
            var cb = checkboxes[i];
            var val = (cb.value || '').toLowerCase();
            var labelText = cb.parentElement ? (cb.parentElement.textContent || '').toLowerCase() : '';
            if (val === modelQuery || labelText.indexOf(modelQuery) !== -1) {
              matchedCheckbox = cb;
              break;
            }
          }

          if (matchedCheckbox) {
            if (!matchedCheckbox.checked) {
              matchedCheckbox.checked = true;
              matchedCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
              matchedCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
            }
          } else {
            // Instant client-side filtering fallback across product cards
            var productCards = document.querySelectorAll('.productGrid .product, .products-grid .product, .productListing .product, #CollectionProductGrid .product');
            if (productCards.length) {
              productCards.forEach(function (card) {
                var cardText = (card.textContent || '').toLowerCase();
                if (cardText.indexOf(modelQuery) !== -1) {
                  card.style.display = '';
                } else {
                  card.style.display = 'none';
                }
              });
            }
          }
        }

        if (href && href.charAt(0) === '#') {
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            var header = document.querySelector('.header, .header-sticky, .sticky-header');
            var offset = header ? header.offsetHeight + 20 : 90;
            var rect = target.getBoundingClientRect();
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            window.scrollTo({
              top: rect.top + scrollTop - offset,
              behavior: 'smooth'
            });
          }
        }
      });
    });
  }

  function init(root) {
    var scope = root || document;
    normalizeAnnouncementBar(scope);
    routeRentalMenuLinks(scope);
    initCollectionLanding(scope);
    prepareServerRenderedBlocks(scope);
    prepareCardImages(scope);
    prepareProductDescriptionAccordions(scope);
    closeRefurbishmentGuide(scope);
    scope.querySelectorAll('[data-codex-coupon-form]').forEach(prepareCoupon);
    window.reventInitCoupons = function (subScope) {
      (subScope || document).querySelectorAll('[data-codex-coupon-form]').forEach(prepareCoupon);
    };
    initFooterFloatingObserver();
    initPdpTopPriceObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      if (document.querySelector('[data-codex-coupon-form]')) {
        removePreviewLines().catch(function () {});
      }
    }, { once: true });
  } else {
    init(document);
    if (document.querySelector('[data-codex-coupon-form]')) {
      removePreviewLines().catch(function () {});
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  function safetyClearStuckLoaders() {
    if (document.body.classList.contains('has-halo-loader')) {
      document.body.classList.remove('has-halo-loader');
    }
    document.querySelectorAll('.loading-overlay:not(.hidden)').forEach(function (el) {
      if (el.closest('#MainContent') || el.closest('.collection') || el.closest('.productListing')) {
        el.classList.add('hidden');
      }
    });
  }

  window.addEventListener('load', function () {
    setTimeout(safetyClearStuckLoaders, 800);
  });
})();
